var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.show)?_c('w-btn',{directives:[{name:"print",rawName:"v-print",value:(_setup.printObject),expression:"printObject"}],attrs:{"color":_vm.error ? 'red' : 'blue-grey',"loading":_setup.loading,"disabled":_vm.disabled,"text":_vm.$t('common.print'),"icon":_vm.error ? 'mdi-alert' : 'mdi-printer'}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }